export default __webpack_public_path__ + "static/media/sherlock.f705c1d8.png";